import { Price } from "~/common/Store/models/ProductListing";
import { User } from "~/common/Store/models/User";
import itemHasMapStyle from "./itemHasMapStyle";

const shouldDisplayBelowMapPrice = (price: Price, user: User) => {
  const mapStyle = price.minimumAdvertisedPriceProperties?.type?.trim();
  const userIsPlatPlus = user.platinum.enabled || user.hasWebPlus;
  const qualifiedForYPricing =
    userIsPlatPlus || user.amountSpentFiveThousandOrMore;

  const qualifiedForJPricing =
    userIsPlatPlus || user.amountSpentOneThousandOrMore;

  switch (mapStyle) {
    case "J":
      return qualifiedForJPricing;
    case "Y":
      return qualifiedForYPricing;
    default:
      return true;
  }
};

export default (
  price: Price,
  user: User,
  activeSale: boolean,
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean,
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean,
  showPlusPricing?: boolean,
) => {
  const hasMAPStyle = itemHasMapStyle(price, activeSale);
  const hasPlusPrice =
    price.minimumAdvertisedPriceOverride?.priceLevel5 && user.hasWebPlus;

  let lowestPrice = Math.min(
    activeSale ? price.salePrice : Infinity,
    price.price,
  );

  if (hasMAPStyle && user.registered) {
    if (
      ((user.platinum && user.platinum.enabled) || user.hasWebPlus) &&
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers
    ) {
      lowestPrice = Math.min(
        price.minimumAdvertisedPriceOverride.priceLevel5 || Infinity,
        price.minimumAdvertisedPriceProperties.price || Infinity,
        lowestPrice,
      );
    } else if (
      showBelowMinimumAdvertisedPriceForLoggedInCustomers ||
      showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers
    ) {
      if (shouldDisplayBelowMapPrice(price, user)) {
        lowestPrice = Math.min(
          price.minimumAdvertisedPriceProperties.price || Infinity,
          lowestPrice,
        );
      }
    }
  }

  if (hasPlusPrice && showPlusPricing) {
    lowestPrice = Math.min(
      price.minimumAdvertisedPriceOverride.priceLevel5 || Infinity,
      lowestPrice,
    );
  }

  return lowestPrice;
};
